import { DAYS_OF_WEEK } from './enums';

export const DAYS_OF_WEEK_SELECT_OPTIONS = [
  { value: DAYS_OF_WEEK.SUNDAY, label: 'Sunday' },
  { value: DAYS_OF_WEEK.MONDAY, label: 'Monday' },
  { value: DAYS_OF_WEEK.TUESDAY, label: 'Tuesday' },
  { value: DAYS_OF_WEEK.WEDNESDAY, label: 'Wednesday' },
  { value: DAYS_OF_WEEK.THURSDAY, label: 'Thursday' },
  { value: DAYS_OF_WEEK.FRIDAY, label: 'Friday' },
  { value: DAYS_OF_WEEK.SATURDAY, label: 'Saturday' },
];
